import { z } from "zod/v4";

export const checkoutAttributionSchema = z.object({
  analyticsConsent: z.literal(true),
  adUserData: z.enum(["GRANTED", "DENIED"]),
  adPersonalization: z.enum(["GRANTED", "DENIED"]),
  clientId: z.string().min(1).max(100),
  sessionId: z.number().int().positive(),
  capturedAt: z.number().int().positive(),
});

export type CheckoutAttribution = z.infer<typeof checkoutAttributionSchema>;
export const checkoutAttributionMetadataKey = "checkoutAttribution";
export const checkoutAttributionMaxAgeMs = 24 * 60 * 60 * 1000;
